module.exports = __webpack_public_path__ + "static/media/icon-arrow-white.4135fbeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-arrow-white.svg
// module id = 264
// module chunks = 3